// 列表模块基本结构
export const listModuleBase = {
  control: [],
  filter: [],
  list: [],
  pager: {
    pageSize: 10,
    page: 1,
    total: 0,
  },
  params: {},
  sort: {},
  loading: false,
};

// 用户信息基本结构
export const userInfoBase = {
  uid: 0,
  nickname: '',
  sex: 0,
  birthday: '',
  score: 0,
  exp: 0,
  province: '',
  city: '',
  district: '',
  entity: '',
  login: 1,
  reg_ip: 0,
  reg_time: 0,
  last_login_ip: 0,
  last_login_time: 0,
  file_download: '',
  pc_sid: '',
  mo_sid: '',
  status: 1,
  head_id: 0,
  mobile: '',
  qq_openid: '',
  wx_unionid: '',
  vip: '',
  medal: {
    total_count: 0,
    count: 0
  },
  medalList: []
};
